// @flow

export default {
  wizard: {
    next: 'Siguiente',
    back: 'Atrás',
    skip: 'Saltar',
    sort: 'Ordenar',
    sorting: {
      'utility:desc': 'Mejores resultados',
      'price:asc': 'Precio ascendente',
      'price:desc': 'Precio descendente',
      'created_at:desc': 'Más recientes primero',
      'customer_rating:desc': 'Valoración de los clientes'
    },
    clickToAddFiles: 'Haz clic para cargar. Alternativamente, puedes arrastrar los archivos al campo.',
    searchFor: 'Buscar ...',
    noSearchResults: 'Lamentablemente, no encontramos opciones adecuadas. Por favor, intenta buscar de nuevo.',
    loadMoreAnswerOptions: '¿No hay una opción adecuada? Mostrar todas las opciones.',
    noRecommendationDescription: 'Oh no, no pudimos encontrar productos que se ajusten a tus necesidades.',
    noRecommendationDescription2: 'Por favor, reinicia la consulta.',
    noRecommendationRestartButtonTitle: 'Reiniciar',
    noRecommendationCloseButtonTitle: 'Cerca',
    removeFile: 'Eliminar archivo'
  },
  chatbot: {
    selectAll: 'Seleccionar todo',
    none: 'Ninguno de estos',
    confirmButton: 'Enviar',
    customerServiceInputPlaceholder: 'Escribir mensaje ...',
    you: 'Tú',
    restart: 'empezar de nuevo',
    close: 'Cerca',
    send: 'Enviar',
    supportChat: 'Chat de soporte',
    honeypot: 'Por favor deje este campo en blanco',
    scrollToTheLatestMessage: 'Desplázate hasta el último mensaje',
    removeFile: 'Eliminar archivo'
  },
  product: {
    loadMore: 'Mostrar más productos',
    badgeTitle: 'Nuestra recomendación',
    ctaButtonTitle: 'Descubrir producto',
    matchingPanelTitle: 'Adaptado para ti',
    bestFit: 'Mejor ajuste',
    bestPrice: 'Precio más bajo',
    bestFitForPrice: 'Mejor relación calidad-precio',
    addToCartError: 'No se pudo añadir al carrito. Por favor, inténtalo de nuevo.',
    addRoutineToCart: 'Añadir al carrito',
    explanationHeader: 'Más información sobre el producto:',
    emptyRoutineItem: 'Lamentablemente, no hay un producto adecuado en esta categoría.'
  },
  tabBar: {
    chat: 'Chat',
    productAdvisor: 'Asesoramiento de productos'
  },
  recommender: {
    answerOptionLeadsToNoRecommendation: 'Lamentablemente, esta opción no conduciría a un producto deseado. Puedes cambiar tu preferencia en pasos anteriores para activar esta opción.'
  }
}
